"use client"

// Browser page translation (Chrome's Google Translate) swaps React's text
// nodes for its own <font> nodes. React then calls removeChild/insertBefore on
// a node that is no longer a child and throws NotFoundError, which crashes the
// survey for candidates reading in Spanish (error-patrol 2026-10-19: 37
// crashes, all es-language browsers). Workaround from facebook/react#11538:
// skip the call instead of throwing.
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) return child
    return originalRemoveChild.call(this, child) as T
  }
  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) return newNode
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}

export function TranslateGuard() {
  return null
}
